import React, { createContext, useState } from 'react'
import { IOrderData, TMeltingLot, TLineDetails, TInboundFields, TCharge, TTransitionHistory } from '../Models/Inbound';
import { TTransferPvcToPlant } from '../Models/TrasferOrderPvcToPlant';
import { TCartItem, TLineItem, TSku } from '../Models/PhysicalOrder';
import { TDelivery } from '../Models/Delivery';
import { TBilling, TPayment } from '../Models/Billing';
import { TStepsKeys } from '../Models/common';
import { TOrder, TTransactionBasic, TTransactionDocuments, TTransactionImage, TTransactionSummary } from '../Models/Transactions';
import { IPvcCenterSummary } from '../Models/PVC';
import { TInventory } from '../Models/Inventory';

export type TEcomTransactionContext = {
  lineItems: TLineItem[], setLineItems: React.Dispatch<React.SetStateAction<TLineItem[]>>
  ecomphysicalOrder: TOrder, setecomphysicalOrder: React.Dispatch<React.SetStateAction<TOrder>>
  deliveryData: TDelivery[], setDeliveryData: React.Dispatch<React.SetStateAction<TDelivery[]>>
  billingData: TBilling, setBillingData: React.Dispatch<React.SetStateAction<TBilling>>,
  capturedSteps: TStepsKeys[], setCapturedSteps: React.Dispatch<React.SetStateAction<TStepsKeys[]>>,
  transactionInfo: TTransactionBasic, setTransactionInfo: React.Dispatch<React.SetStateAction<TTransactionBasic>>,
  transactions: TTransactionSummary[], setTransactions: React.Dispatch<React.SetStateAction<TTransactionSummary[]>>,
  products: TSku[], setProducts: React.Dispatch<React.SetStateAction<TSku[]>>,
  cart: TCartItem[], setCart: React.Dispatch<React.SetStateAction<TCartItem[]>>,
  charges: TCharge[], setCharges: React.Dispatch<React.SetStateAction<TCharge[]>>,
  payments: TPayment[], setPayments: React.Dispatch<React.SetStateAction<TPayment[]>>,
  transitionHistory:TTransitionHistory[], setTransitionHistory: React.Dispatch<React.SetStateAction<TTransitionHistory[]>>,
  pvcCenterDetails:IPvcCenterSummary, setPvcCenterDetails: React.Dispatch<React.SetStateAction<IPvcCenterSummary>>,
  pvcCenters:IPvcCenterSummary[], setPvcCenters: React.Dispatch<React.SetStateAction<IPvcCenterSummary[]>>,
  isInventoryExist: boolean, setIsInventory: React.Dispatch<React.SetStateAction<boolean>>,
  transactionDocuments:TTransactionDocuments[], setTransactionDocuments: React.Dispatch<React.SetStateAction<TTransactionDocuments[]>>,
  transactionImages:TTransactionImage[],setTransactionImages:React.Dispatch<React.SetStateAction<TTransactionImage[]>>,
  resetOrder: () => any
}

export const EcomTransactionContext = createContext<TEcomTransactionContext>({} as TEcomTransactionContext)

const EcomTransactionProvider = (props: any) => {

  const [lineItems, setLineItems] = useState<TLineItem[]>([] as TLineItem[])
  const [ecomphysicalOrder, setecomphysicalOrder] = useState<TOrder>({} as TOrder)
  const [deliveryData, setDeliveryData] = useState<TDelivery[]>([] as TDelivery[])
  const [billingData, setBillingData] = useState<TBilling>({} as TBilling)
  const [payments, setPayments] = useState<TPayment[]>([])
  const [capturedSteps, setCapturedSteps] = useState<TStepsKeys[]>([])
  const [transactionInfo, setTransactionInfo] = useState<TTransactionBasic>({} as TTransactionBasic)
  const [transactions, setTransactions] = useState<TTransactionSummary[]>([])
  const [transitionHistory, setTransitionHistory] = useState<TTransitionHistory[]>([])
  const [products, setProducts] = useState<TSku[]>([])
  const [cart, setCart] = useState<TCartItem[]>([])
  const [charges, setCharges] = useState<TCharge[]>([])
  const [pvcCenterDetails,setPvcCenterDetails] = useState<IPvcCenterSummary>({} as IPvcCenterSummary)
  const [pvcCenters, setPvcCenters] = useState<IPvcCenterSummary[]>([])
  const [isInventoryExist, setIsInventory] = useState<boolean>(false)
  const [transactionDocuments, setTransactionDocuments] = useState<TTransactionDocuments[]>([])
  const [transactionImages, setTransactionImages] = useState<TTransactionImage[]>([])

    const resetOrder = () => {
    setecomphysicalOrder({} as TOrder)
    setDeliveryData([] as TDelivery[])
    setBillingData({} as TBilling)
    setPayments([])
    setTransactionInfo({} as TTransactionBasic)
    setTransactions([])
    setCapturedSteps([])
    setTransactionInfo({} as TTransactionBasic)
    setTransactions([])
    setProducts([])
    setCart([])
    setCharges([])
    setTransitionHistory([])
    setPvcCenterDetails({} as IPvcCenterSummary)
    setPvcCenters([])
    setLineItems([])
    setTransactionDocuments([])
    setTransactionImages([])
  }

  return (
    <EcomTransactionContext.Provider
      value={{
        ecomphysicalOrder, setecomphysicalOrder,
        deliveryData, setDeliveryData,
        billingData, setBillingData,
        capturedSteps, setCapturedSteps,
        transactionInfo, setTransactionInfo,
        transactions, setTransactions,
        products, setProducts,
        cart, setCart,
        lineItems, setLineItems,
        charges, setCharges,
        payments, setPayments,
        transitionHistory, setTransitionHistory,
        pvcCenterDetails,setPvcCenterDetails,
        pvcCenters, setPvcCenters,
        resetOrder,
        isInventoryExist, setIsInventory,
        transactionDocuments, setTransactionDocuments,
        transactionImages, setTransactionImages
      }}>
      {props.children}
    </EcomTransactionContext.Provider>
  )
}

export default EcomTransactionProvider
